module.exports = (fn, delay) => {
  let timer = null;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    return timer = setTimeout(() => fn.apply(context, args)
    , delay);
  };
};
